import React from 'react';
import Svg from '@svg/index';
import { Subtext } from '@ui-library/typography';
import { RudderstackLogo } from '@ui-library/brandLogo';
import { Button } from '@ui-library/button';
import { useTheme } from 'styled-components';
import { PageContainer, CopyContainer, Hero } from './styles';

export const ErrorPage = () => {
  const { token } = useTheme();
  return (
    <PageContainer flexDirection="column" justifyContent="space-between" flexGrow alignItemsCenter>
      <CopyContainer
        gap=".5em"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <RudderstackLogo size={30} />
        <Hero className="m-t-lg">Sorry about this...</Hero>
        <Subtext color={token.colorTextDescription} className="m-t-sm m-b-lg">
          Something went wrong loading this page. Let's try again.
        </Subtext>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </CopyContainer>
      <Svg name="error-page-bg-image" />
    </PageContainer>
  );
};
